import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-whatsapp-button',
  templateUrl: './whatsapp-button.component.html',
  styleUrls: ['./whatsapp-button.component.css'],
  standalone: false
})
export class WhatsappButtonComponent implements OnInit, OnChanges {
  @Input() phoneNumber: string | null | undefined = '5491155555555'; // Número predeterminado
  @Input() pas: string | null | undefined = '';

  whatsappLink: string = '';

  constructor(private http: HttpClient) {}


  ngOnInit(): void {
    this.updateWhatsappLink();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['phoneNumber'] || changes['pas']) {
      this.updateWhatsappLink();
    }
  }

  updateWhatsappLink(): void {
    const defaultText = encodeURIComponent(
      `Hola ${this.pas}! 👋 Te escribo por Coverit. Me gustaría recibir información sobre seguros (Praxis Médica, Automotor, Moto o Medicina Prepaga) Gracias!`
    );
    this.whatsappLink = `https://api.whatsapp.com/send?phone=${this.phoneNumber}&text=${defaultText}`;
  }

}
